import { render, staticRenderFns } from "./BlockQuote.vue?vue&type=template&id=b515c0d4&"
import script from "./BlockQuote.vue?vue&type=script&lang=js&"
export * from "./BlockQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports